module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [(_vm.image) ? _vm._c('div', {
    staticClass: "banner",
    style: ('background-image:url(' + _vm.image + ');')
  }) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "home-body"
  }, [_vm._c('div', {
    staticClass: "container sm-pt-50 xs-pb-50"
  }, [(_vm.blogArticle) ? _vm._c('div', {
    staticClass: "article"
  }, [_vm._c('h1', {
    staticClass: "weight500 x-large-text xs-mb-20 md-mb-50"
  }, [_vm._v(_vm._s(_vm.blogArticle.title))]), _vm._v(" "), _vm._c('div', {
    staticClass: "date large-text xs-mb-20 md-mb-50"
  }, [_vm._v("\n          " + _vm._s(_vm.blogArticle.created_at_formatted) + "\n        ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_vm._c('div', {
    staticClass: "article-content"
  }, [_vm._c('div', {
    staticClass: "content text-justify  large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.blogArticle.content)
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "xs-mt-50 xs-mb-50 text-center"
  }, [_vm._c('router-link', {
    staticClass: "btn-pub btn-pub-border-primary xs-full-width",
    attrs: {
      "to": {
        name: 'blog'
      }
    }
  }, [_vm._v("Back To Posts")])], 1), _vm._v(" "), _vm._c('HorizontalAd', {
    attrs: {
      "containerClass": ''
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "row xs-mt-50",
    attrs: {
      "id": "comments"
    }
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('BlogCommentsList', {
    attrs: {
      "comments": _vm.blogArticle.comments,
      "articleId": _vm.blogArticle.id
    }
  })], 1)])], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "hidden-sm hidden-xs col-md-3"
  }, [_vm._c('div', {
    staticClass: "wrap-blue xs-mb-50 signup-block large-text"
  }, [_vm._c('span', {
    staticClass: "weight500"
  }, [_vm._v("Learn Smarter, Organize Notes, Remember Everything.")]), _vm._c('br'), _vm._c('br'), _vm._v("\n              Get Started With Us, For Free!"), _vm._c('br'), _vm._c('br'), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-blank",
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_vm._v("Sign Up Today")])], 1), _vm._v(" "), _vm._c('VerticalAd', {
    attrs: {
      "containerClass": ''
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "wrap-black xs-mt-50 signup-block large-text"
  }, [_vm._c('span', {
    staticClass: "weight500"
  }, [_vm._v("Learn Smarter, Organize Notes, Remember Everything.")]), _vm._c('br'), _vm._c('br'), _vm._v("\n              Get Started With Us, For Free!"), _vm._c('br'), _vm._c('br'), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-blank",
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_vm._v("Sign Up Today")])], 1)], 1)])]) : _vm._c('div', [_vm._c('LoadingIndicator')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a37665a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/BlogArticlePage.vue
// module id = 702
// module chunks = 1